var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScheduleSelectionIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ejIViueFrSp1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 300 300",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 30.572118,
    ry: 30.572118,
    transform: "matrix(.572417 0 0 0.572417 150.000001 150.000001)",
    fill: "#fff",
    strokeWidth: 0
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 30.572118,
    ry: 30.572118,
    transform: "matrix(.572417 0 0 0.572417 150.000001 100.000001)",
    fill: "#fff",
    strokeWidth: 0
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 30.572118,
    ry: 30.572118,
    transform: "matrix(.572417 0 0 0.572417 200.000001 150.000001)",
    fill: "#fff",
    strokeWidth: 0
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 30.572118,
    ry: 30.572118,
    transform: "matrix(.572417 0 0 0.572417 100.000001 150.000001)",
    fill: "#fff",
    strokeWidth: 0
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 30.572118,
    ry: 30.572118,
    transform: "matrix(.572417 0 0 0.572417 200.000001 100.000001)",
    fill: "#fff",
    strokeWidth: 0
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 30.572118,
    ry: 30.572118,
    transform: "matrix(.572417 0 0 0.572417 200.000001 200.000001)",
    fill: "#fff",
    strokeWidth: 0
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 30.572118,
    ry: 30.572118,
    transform: "matrix(.572417 0 0 0.572417 150.000001 200.000001)",
    fill: "#fff",
    strokeWidth: 0
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 30.572118,
    ry: 30.572118,
    transform: "matrix(.572417 0 0 0.572417 100.000001 200.000001)",
    fill: "#fff",
    strokeWidth: 0
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 30.572118,
    ry: 30.572118,
    transform: "matrix(.572417 0 0 0.572417 100.000001 100.000001)",
    fill: "#fff",
    strokeWidth: 0
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleSelectionIcon);
export default __webpack_public_path__ + "static/media/schedule-selection-icon.b9249b60c5dee6d5e6d99992c9130f80.svg";
export { ForwardRef as ReactComponent };